import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import SesionSinRespuesta from "@/components/SesionSinRespuesta";
import SesionFrenada from "@/components/SesionFrenada";

export default function AdminRoute({ children }) {
  const { user, ready, sesion } = useAuth();
  const location = useLocation();

  if (!ready) {
    return (
      <div className="min-h-[calc(100vh-4rem)] dvh:min-h-[calc(100svh-4rem)] bg-white flex items-center justify-center">
        <div className="font-mono-alpha text-[11px] uppercase tracking-widest text-alpha-black/40">
          Verificando sesión...
        </div>
      </div>
    );
  }
  // SIN RESPUESTA NO ES ESTAR FUERA (24 sep 2026). Si el servidor no ha contestado a «¿quién
  // soy?» —red, 502, tiempo agotado—, no se manda a nadie a la pantalla de acceso: se dice que
  // no se ha podido comprobar y se ofrece reintentar. El porqué, en `context/AuthContext.jsx`.
  if (sesion === "sin-respuesta") {
    return <SesionSinRespuesta />;
  }
  // Y UN FRENO TAMPOCO ES ESTAR FUERA (6 oct 2026). El servidor ha contestado —429, «vas
  // demasiado rápido»— y hasta dice cuánto falta. Ni formulario de acceso ni pantalla de
  // reconexión: se dice lo que pasa y no se reintenta solo.
  if (sesion === "freno") {
    return <SesionFrenada />;
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (user.role !== "admin") {
    return <Navigate to="/" replace />;
  }
  return children;
}
